export const IMAGES = {
  heroSkyline:
    "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxkdWJhaSUyMGx1eHVyeSUyMGJ1c2luZXNzJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc4NjQyMTY3M3ww&ixlib=rb-4.1.0&q=85",
  business:
    "https://images.unsplash.com/photo-1518684079-3c830dcef090?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxkdWJhaSUyMGx1eHVyeSUyMGJ1c2luZXNzJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc4NjQyMTY3M3ww&ixlib=rb-4.1.0&q=85",
  carLifestyle:
    "https://images.unsplash.com/photo-1778507936291-bc3e9692ff33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBkdWJhaSUyMG5pZ2h0fGVufDB8fHx8MTc4NjQyMTY3M3ww&ixlib=rb-4.1.0&q=85",
  carNight:
    "https://images.unsplash.com/photo-1765195027028-d1d3d9c55446?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBkdWJhaSUyMG5pZ2h0fGVufDB8fHx8MTc4NjQyMTY3M3ww&ixlib=rb-4.1.0&q=85",
};

const PIMG = [
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&q=80",
  "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1200&q=80",
  "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1200&q=80",
  "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=80",
];

export const DEMO_PROPERTIES = [
  { id: "p1", title: "Marina Gate Residence", building: "Marina Gate", area: "Dubai Marina", bedrooms: 2, baths: 3, price: 1850000, size: 1180, tags: ["Marina view", "Chiller free"], market: "fair", freshness: "3 days ago", image: PIMG[0] },
  { id: "p2", title: "Vida Residences", building: "Vida Residences", area: "Downtown Dubai", bedrooms: 2, baths: 2, price: 1975000, size: 1240, tags: ["Branded", "Furnished"], market: "below", freshness: "1 day ago", image: PIMG[1] },
  { id: "p3", title: "Bluewaters Bay", building: "Bluewaters Bay", area: "Bluewaters", bedrooms: 3, baths: 4, price: 3200000, size: 1600, tags: ["Sea view", "New handover"], market: "above", freshness: "6 days ago", image: PIMG[2] },
  { id: "p4", title: "Creek Horizon", building: "Creek Horizon", area: "Dubai Creek Harbour", bedrooms: 1, baths: 1, price: 1250000, size: 720, tags: ["Skyline view", "Payment plan"], market: "fair", freshness: "2 days ago", image: PIMG[3] },
];

export const DEMO_COMPS = [
  { building: "Marina Gate", size: 1160, price: 1810000, date: "Mar 2025" },
  { building: "Marina Gate", size: 1205, price: 1910000, date: "Jan 2025" },
  { building: "Vida", size: 1240, price: 1975000, date: "Feb 2025" },
];

export const DEMO_QUOTES = [
  { name: "Prime Care Services", price: "AED 220", availability: "Tonight 8–10pm", response: "12 min", warranty: "90 days", score: 96 },
  { name: "Elite Maintenance Co.", price: "AED 190", availability: "Tomorrow AM", response: "25 min", warranty: "60 days", score: 92 },
  { name: "Falcon Home Experts", price: "AED 240", availability: "Tonight 9pm", response: "8 min", warranty: "120 days", score: 94 },
];

// Areas/buildings that have CMA demo data (kept in sync with backend DEMO_TX)
export const CMA_AREAS = ["Dubai Marina", "Downtown Dubai", "Jumeirah Village Circle", "Emaar Beachfront"];
